import { useCallback, useMemo, useState } from 'react';
// context
import { TableContext } from './table-context';

// ----------------------------------------------------------------------

const initialState = {
  table_data: null,
  table_header: null,
  table_rows: null,
  table_row_selected: null,
  table_import_data: null,
  table_export_data: null,
  table_print_pdf_data: null,
  table_print_pdf_template: null,
  table_pagination_data: null,
  filter_params: null,
  filter_data: null,
  table_row_deteled_failed: null,
  table_export_excel: null,
  table_configs: {
    table_name: '',
    table_name_prefix: '',
    access_roles: [],
    create_role: '',
    update_role: '',
    delete_role: '',
    //
    filter_by_date: false,
    filter_by_type: false,
    filter_by_search: false,
    filter_by_code: false,
    //
    add_data: false,
    chart_data: false,
    access_data: false,
    history_data: false,
    album_data: false,
    import_data: false,
    note_table: false,
    check_data: false,
    report_data: false,
    search_barcode: false,
    export_data_pdf: false,
    export_data_json: false,
    export_data_excel: false,
    //
    table_selected: false,
    delete_all: false,
    //
    watch_row: false,
    print_row: false,
    change_status_row: false,
    watch_history: false,
    edit_row: false,
    delete_row: false,
    //
    delete_api: () => {},
    delete_many_api: () => {},
    create_many_api: () => {},
  },
  //
  table_open_form: false,
  table_open_form_return_book: false,
  table_return_book_data: null,
  table_open_other_form: false,
  table_other_form_data: null,
  table_open_third_form: false,
  table_third_form_data: null,
};

type Props = {
  children: React.ReactNode;
};

export function TableProvider({ children }: Props) {
  const [values, setValues] = useState(initialState);

  // cập nhật state
  const setTableValue = useCallback(
    (name: string, value: any) => {
      setValues((prevState: any) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [setValues]
  );

  // thêm dữ liệu mới vào bảng
  const onCreateNewRow = useCallback(
    async (newRow: any) => {
      // @ts-ignore
      setTableValue('table_data', [newRow, ...values.table_data]);
    },
    [setTableValue, values.table_data]
  );

  // thêm dữ liệu mới vào bảng
  const onCreateNewManyRow = useCallback(
    (newRows: any) => {
      // @ts-ignore
      setTableValue('table_data', [...newRows, ...values.table_data]);
    },
    [setTableValue, values.table_data]
  );

  // cập nhật dữ liệu trong bảng
  const onUpdateRow = useCallback(
    (updateRow: any) => {
      console.log('onUpdateRow', updateRow);
      const rowSelected = values.table_row_selected as any;

      // @ts-ignore
      const updated = Array.isArray(values.table_data)
        ? (values.table_data as any[]).map((item: any) => {
            if (item.id === rowSelected) {
              console.log('updateRow', rowSelected);

              return {
                ...rowSelected,
                ...updateRow,
              };
            }
            return item;
          })
        : [];
      console.log('afterUpdateRow', updated);

      setTableValue('table_data', updated);
    },
    [setTableValue, values.table_data]
  );

  const memoizedValue = useMemo(
    () => ({
      ...values,
      setTableValue,
      //
      onCreateNewRow,
      onCreateNewManyRow,
      onUpdateRow,
    }),
    [
      values,
      setTableValue,
      //
      onCreateNewRow,
      onCreateNewManyRow,
      onUpdateRow,
    ]
  );

  return <TableContext.Provider value={memoizedValue}>{children}</TableContext.Provider>;
}
